import * as z from "zod/v4";

const mobileMessageConversationSummary = z.object({
  conversationId: z.string(),
  customerPhone: z.string(),
  aiDisabled: z.boolean(),
  lastMessageAt: z.string().nullable(),
  lastMessagePreview: z.string().nullable(),
  lastMessageSender: z.string().nullable(),
  createdAt: z.string(),
  activeFlowTypes: z.array(z.string()),
});

export const adminListMobileMessageConversations = {
  name: "adminListMobileMessageConversations" as const,
  input: z.object({
    teamId: z.string(),
    limit: z.number().optional(),
    offset: z.number().optional(),
  }),
  output: z.object({
    conversations: z.array(mobileMessageConversationSummary),
    total: z.number(),
  }),
};
